<template>
    <v-img v-bind="{ ...$attrs, src }" :aspect-ratio="232 / 68" max-width="160" contain class="w-100">
        <v-fade-transition>
            <v-overlay v-show="!src" absolute color="white">
                <image-overlay />
                <!-- <v-icon color="black">mdi-domain</v-icon> -->
            </v-overlay>
        </v-fade-transition>
    </v-img>
</template>

<script>
import ImageOverlay from "@/components/dumb/image-overlay.vue";
export default {
    components: {
        ImageOverlay,
    },
    props: {
        company: { type: Object, default: () => ({}) },
    },
    computed: {
        src() {
            return this.company?.logo?.url;
        },
    },
};
</script>

<style>
</style>